import { forwardRef, useImperativeHandle, useRef, useState } from "react";

import "./audioPlayer.scss";

export interface AudioPlayerHandle {
  play: () => void;
  pause: () => void;
  setVolume: (v: number) => void;
  setSrc: (src: string) => void;
  setVisible: (visible: boolean) => void;
}

const AudioPlayer = forwardRef<AudioPlayerHandle>((_, ref) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    play: () => {
      audioRef.current?.play();
      setIsPlaying(true);
      setIsVisible(true);
    },
    pause: () => {
      audioRef.current?.pause();
      setIsPlaying(false);
    },
    setVolume: (v) => {
      if (audioRef.current) audioRef.current.volume = v;
    },
    setSrc: (src) => {
      if (audioRef.current) {
        audioRef.current.src = src;
        audioRef.current.load();
        setIsVisible(true);
      }
    },
    setVisible: (visible) => {
      setIsVisible(visible);
      if (!visible) audioRef.current?.pause();
    },
  }));

  const togglePlayback = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div className="audio-player">
      <audio ref={audioRef} loop={true} />
      {isVisible && (
        <button className="audio-player__toggle" onClick={togglePlayback}>
          <div className="audio-player__image">
            {isPlaying ? <img src="icon-playing.svg" alt="Pause" /> : <img src="icon-muted.svg" alt="Play" />}
          </div>
        </button>
      )}
    </div>
  );
});

export default AudioPlayer;
